export const myConfig = {
    serverAddress: process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : 'https://testdrive.motorimage.net',
    callbackUrl: process.env.NODE_ENV === 'development' ? process.env.REACT_APP_CALLBACK_STAGING_URL : process.env.REACT_APP_CALLBACK_PRO_URL
};